import { FC, ReactNode } from "react";
import classNames from "classnames";
import { Button } from "components/atoms";
import { useScreenSize } from "hooks";
import { MOBILE_WIDTH } from "utils/constants";
import { AccordionDropDownIcon } from "components/atoms/Icon";
import "./AccordionItem.scss";

interface AccordionItemProps {
  title: string;
  isOpen: boolean;
  children: ReactNode;
  onToggle: () => void;
  styles?: string;
  theme: "light" | "dark";
}

export const AccordionItem: FC<AccordionItemProps> = ({
  title,
  children,
  isOpen,
  onToggle,
  styles,
  theme,
}) => {
  const screen = useScreenSize();

  return (
    <div
      className={classNames({
        "view-prep-accordion-item": true,
        open: isOpen,
        [`${styles}`]: styles,
      })}
    >
      <div className={classNames("view-prep-accordion-header")} onClick={onToggle}>
        <div className={classNames("title")}>{title}</div>
        {screen.width < MOBILE_WIDTH ? (
          <AccordionDropDownIcon
            onClick={onToggle}
            isClicked={isOpen}
            bgColor={theme === "light" ? "#273E5A" : "#329EE2"}
            arrowColor={theme === "light" ? "#fff" : "#000"}
          />
        ) : (
          <Button
            icon={false}
            label={isOpen ? "Close" : "View"}
            type="score"
            onClick={onToggle}
            styles="view-prep-accordion-button"
          />
        )}
      </div>
      {isOpen && (
        <div className={classNames("view-prep-accordion-content")}>{children}</div>
      )}
    </div>
  );
};
